export const clampLayerToScreen = ({
  xLeft,
  layerWidth,
  screenWidth,
  safeZone,
}: {
  xLeft: number;
  layerWidth: number;
  screenWidth: number;
  safeZone: number;
}): number => Math.max(safeZone, Math.min(xLeft, screenWidth - safeZone - layerWidth));
